import { Component, inject } from '@angular/core';
import { CoreService } from '@ukam/shell/services/core.service';

@Component({
  selector: 'app-branding',
  imports: [],
  template: `
    <a href="/" class="logodark">
      <img
        [src]="options.logoDark"
        class="align-middle m-2 rtl:-scale-x-100"
        alt="logo"
      />
    </a>

    <a href="/" class="logolight">
      <img
        [src]="options.logoLight"
        class="align-middle m-2 rtl:-scale-x-100"
        alt="logo"
      />
    </a>
  `,
})
export class BrandingComponent {
  private settings = inject(CoreService);

  options = this.settings.getOptions();
}
